module.exports = __webpack_public_path__ + "img/pgiftcard.bcc6a79.png";